<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="full"
      :visible.sync="modalVisible"
      :loading="loading"
      :confirm-loading="confirmLoading"
      :contentStyle="{'height': '100%', 'display': 'flex', 'flex-direction': 'column'}"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      {{deliveryOrder.code}}
      <gj-tag
          type="plain"
          shape="rectangle"
          :color="deliveryOrder.status | optionColor(DeliveryOrderEnum.statusOption)">
        {{ deliveryOrder.status | optionText(DeliveryOrderEnum.statusOption) }}
      </gj-tag>
    </template>
    <template #content>
      <div class="check-content">
      <gj-area-title>基本信息</gj-area-title>
      <gj-desc-group
          :label-width="'90px'"
          style="margin-bottom: 4px;">
        <el-row :gutter="10" style="margin-bottom: 5px;">
          <el-col :span="8">
            <gj-desc
                label="采购仓"
                :content="deliveryOrder.deliveryWarehouseName | defaultShow">
            </gj-desc>
          </el-col>
          <el-col :span="8">
            <gj-desc
                label="供应商"
                :content="deliveryOrder.supplierName | defaultShow">
            </gj-desc>
          </el-col>
          <el-col :span="8">
            <gj-desc
                label="结算方式">
              {{deliveryOrder.settlementWay | optionText(DeliveryOrderEnum.settleOption) | defaultShow}}
            </gj-desc>
          </el-col>
        </el-row>
        <el-form >
          <el-row :gutter="10" class="amount-row">
            <el-col :span="8">
              <gj-desc label="运费">
                <template v-if="viewOpType">
                  {{ data.feeCurrency }}-{{data.transportFee}}
                </template>
                <el-form-item
                  v-else
                  prop="transportFee.value"
                  :rules="[
                    $gjReRule(RE.num(2), '最多两位小数的正数'),
                    $gjMinRule(0.02, '应大于等于0.02'),
                  ]">
                  <gj-select-input
                    :inputDisabled="viewOpType"
                    :selectDisabled="viewOpType"
                    v-model="form.transportFee"
                    @input="transportFeeInput"
                    :options="[
                        {id: 'CNY', text: 'CNY'},
                        {id: 'USD', text: 'USD'}
                    ]"
                    :width="['85px', '100px']"
                  ></gj-select-input>
              </el-form-item>
              </gj-desc>
            </el-col>
            <el-col :span="8">
              <gj-desc label="其他费用">
                <template v-if="viewOpType">
                  {{ data.feeCurrency }}-{{data.otherFee}}
                </template>
                <el-form-item
                  v-else
                  prop="otherFee.value"
                  :rules="[
                    $gjReRule(RE.num(2), '最多两位小数的正数'),
                    $gjMinRule(0.02, '应大于等于0.02'),
                  ]">
                  <gj-select-input
                    v-model="form.otherFee"
                    :inputDisabled="viewOpType"
                    :selectDisabled="viewOpType"
                    @input="otherFeeInput"
                    :options="[
                        {id: 'CNY', text: 'CNY'},
                        {id: 'USD', text: 'USD'}
                    ]"
                    :width="['85px', '104px']"
                  ></gj-select-input>
                </el-form-item>
              </gj-desc>
            </el-col>
            <el-col :span="8">
              <gj-desc label="分摊方式">
                <template v-if="viewOpType">
                  {{data.shareMethod | shareMethod}}
                </template>
                <el-form-item
                    v-else
                    prop="shareMethod">
                    <gj-select
                      :options="[
                        {id: 'amount', text: '按金额'},
                        {id: 'quantity', text: '按数量'}
                      ]"
                      v-model="form.shareMethod"
                      :clearable="false"
                    ></gj-select>
                </el-form-item>
              </gj-desc>
            </el-col>
          </el-row>
        </el-form>
        <el-row :class="{'row-margin': !viewOpType}">
          <gj-desc
              label="备注">
            <template v-if="viewOpType">
              {{deliveryOrder.memo | defaultShow}}
            </template>
            <gj-input
                v-else
                v-model="form.memo"
                width="95%"
                placeholder="请输入备注"
            ></gj-input>
          </gj-desc>
        </el-row>
        <el-row>
          <gj-desc v-if="viewOpType" label="附件">
            <template v-if="form.files && form.files.length > 0">
              <gj-link
                  v-for="item in form.files"
                  :key="item.id"
                  @click="download(item.attId)"
                  style="margin-right: 8px;">
                {{item.name}}
              </gj-link>
            </template>
            <template v-else>-</template>
          </gj-desc>
          <gj-desc v-else label="附件">
            <gj-upload
                upload-btn-type="default"
                :container-biz-id="deliveryOrder ? deliveryOrder.id : null"
                container-type="DELIVERY_NOTE"
                :acceptType="[]"
                :fileList.sync="form.files"
                specialUpload
            ></gj-upload>
          </gj-desc>
        </el-row>
      </gj-desc-group>
      <el-tabs value="product">
        <el-tab-pane label="交货明细" name="product">
          <app-delivery-order-product
              ref="productForm"
              :form="form"
              :op-type="opType"
          ></app-delivery-order-product>
        </el-tab-pane>
        <el-tab-pane label="入库明细" lazy>
          <app-delivery-order-inbound
              :delivery-order="deliveryOrder"
          ></app-delivery-order-inbound>
        </el-tab-pane>
        <el-tab-pane label="操作日志" lazy>
          <gj-log-table
              adapt-parent
              :url="`/supply/purchaseDeliveryNote/log/page`"
              :columns="DeliveryOrderEnum.logColumns"
              :params="{ model: deliveryOrder.id }"
              :offset-height="55"
          ></gj-log-table>
        </el-tab-pane>
      </el-tabs>
      </div>
    </template>
    <template #footer>
      <gj-button
          @click="cancel"
      >取消</gj-button>
      <gj-button
          v-if="editOpType && $permission('purchaseDeliveryNote:add')"
          :loading="confirmLoading"
          type="primary"
          @click="confirm"
      >确定</gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, opTypeMixin, responseMixin, formRuleMixin} from "@/minxins";
  import AppDeliveryOrderProduct from "./components/delivery-order-product";
  import AppDeliveryOrderInbound from "./components/delivery-order-inbound";
  import {DeliveryOrderEnum} from "../enum";
  import {getDeliveryOrder, getDeliveryOrderProductList, updateDeliveryOrder} from "@/api/purchase";
  import {downloadAttFile} from "@/api/common";

  export default {
    name: "app-op-delivery-order-modal",
    components: {AppDeliveryOrderInbound, AppDeliveryOrderProduct},
    mixins: [modalMixIn, responseMixin, opTypeMixin, formRuleMixin],
    props: {
      deliveryOrder: {
        required: true
      },
    },
    filters: {
      shareMethod(key) {
        switch (key) {
          case "amount":
            return "按金额"
          case "quantity":
            return "按数量"
          default:
            break;
        }
        return "-"
      }
    },
    data() {
      return {
        loading: false,
        form: {
          memo: null,
          files: [],
          items: [],
          transportFee: {
            key: "CNY",
            value: ""
          },
          otherFee: {
            key: "CNY",
            value: ""
          },
          shareMethod: "amount",
        },
        data: {},
        DeliveryOrderEnum: DeliveryOrderEnum,
      }
    },
    created() {
      this.loading = true;
      Promise.all([
        getDeliveryOrder(this.deliveryOrder.id),
        getDeliveryOrderProductList(this.deliveryOrder.id)
      ])
        .then(([data, productData]) => {
          this.data = data;
          this.form.memo = data.memo;
          this.form.transportFee.key = this.data.feeCurrency
          this.form.otherFee.key = this.data.feeCurrency
          this.form.transportFee.value = this.data.transportFee
          this.form.otherFee.value = this.data.otherFee
          this.form.shareMethod = this.data.shareMethod
          // 设置附件
          if (data.attachments) {
            this.form.files = data.attachments.map(item => ({
              name: item.fileName,
              attId: item.id,
            }));
          }
          productData.forEach(item => {
            item.originQuantity = item.deliveryQuantity;
          });
          this.form.items = productData;
        })
        .complete(() => this.loading = false);
    },
    methods: {
      // 其他费用改变
      otherFeeInput() {
        this.form.transportFee.key = this.form.otherFee.key
      },
      // 运费改变
      transportFeeInput() {
        this.form.otherFee.key = this.form.transportFee.key
      },
      download(fileId) {
        downloadAttFile(fileId);
      },
      confirm() {
        if (this.$refs['productForm'].formValidate()) {
          this.confirmLoading = true;
          updateDeliveryOrder({
            id: this.deliveryOrder.id,
            memo: this.form.memo,
            otherFee: this.form.otherFee.value,
            feeCurrency: this.form.otherFee.key,
            shareMethod: this.form.shareMethod,
            transportFee: this.form.transportFee.value,
            product: this.form.items.map(item => ({
              id: item.id,
              purchaseOrderItemId: item.purchaseOrderItemId,
              deliveryQuantity: item.deliveryQuantity,
              originalDeliveryQuantity: item.originQuantity,
            }))
          })
            .then(res => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('操作成功');
                this.$emit('updated');
                this.$gjDestroy();
              })
            })
            .complete(() => this.confirmLoading = false);
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.amount-row {
  /deep/.el-form-item {
    margin-bottom: 6px;
  }
}
/deep/ .el-dialog__body{
  padding: 16px 20px 0;
}
/deep/ .gj-table{
  padding-bottom: 1px;
}
.check-content{
  height: 100%;
  display: flex;
  flex-direction: column;
  /deep/ .el-tabs{
    flex: 1;
    min-height: 450px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    .el-tabs__content{
      flex: 1;
      flex-direction: column;
    }
    .el-tab-pane{
      height: 100%;
    }
  }
  /deep/ .el-form-item__label, /deep/ .el-form-item__content{
    line-height: 28px;
  }
  /deep/ .el-form-item__content{
    // margin-bottom: 12px;
  }
}
.row-margin{
  margin: 6px 0 12px;
}
/deep/ .el-tabs__header{
  margin-bottom: 12px;
}

</style>
